export default __webpack_public_path__ + "static/media/rocket_anim_23.fdee01a4.png";